var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exercise-content"},[_c('c-exercise-progress-bar'),_c('div',{staticClass:"exercise-template"},[_c(_vm.getContent,{key:_vm.getCurrentTemplate,tag:"component"})],1),(_vm.hasSpeakers)?_c('c-speakers'):_vm._e(),(_vm.hasHint)?_c('c-hint-avatar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }